import { type ReactNode } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './marketing.css';

export default function MarketingLayout({ children }: { children: ReactNode }) {
  return (
    <div className="marketing-root">
      <Navbar />
      <main style={{ paddingTop: '76px' }}>{children}</main>
      <Footer />
    </div>
  );
}
